import React from "react";
import { Phone, Users, Bike, Clock } from "lucide-react";
import { RoteristaStats } from "../types";

interface StatsCardsProps {
  stats: RoteristaStats;
  compact?: boolean;
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats, compact = false }) => {
  if (compact) {
    return (
      <div className="grid gap-2">
        <div className="rounded-lg bg-white p-3 shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-neutral-600">Aguardando</p>
              <p className="mt-1 text-2xl font-bold text-neutral-900">
                {stats.totalAguardando}
              </p>
            </div>
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-warning-light">
              <Clock size={18} className="text-warning" />
            </div>
          </div>
        </div>

        <div className="rounded-lg bg-white p-3 shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-medium text-neutral-600">Em Entrega</p>
              <p className="mt-1 text-2xl font-bold text-neutral-900">
                {stats.totalEmEntrega}
              </p>
            </div>
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-success-light">
              <Bike size={18} className="text-success" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <div className="rounded-lg bg-white p-6 shadow">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-neutral-600">Aguardando</p>
            <p className="mt-2 text-3xl font-bold text-neutral-900">
              {stats.totalAguardando}
            </p>
          </div>
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-warning-light">
            <Clock size={24} className="text-warning" />
          </div>
        </div>
      </div>

      <div className="rounded-lg bg-white p-6 shadow">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-neutral-600">Em Entrega</p>
            <p className="mt-2 text-3xl font-bold text-neutral-900">
              {stats.totalEmEntrega}
            </p>
          </div>
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-success-light">
            <Bike size={24} className="text-success" />
          </div>
        </div>
      </div>

      <div className="rounded-lg bg-white p-6 shadow">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-neutral-600">
              Quantidade de Entregadores
            </p>
            <p className="mt-2 text-3xl font-bold text-neutral-900">
              {stats.totalEntregadores}
            </p>
          </div>
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Users size={24} className="text-primary" />
          </div>
        </div>
      </div>

      <div className="rounded-lg bg-white p-6 shadow">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-neutral-600">
              Próximo na Fila
            </p>
            <p className="mt-2 text-lg font-semibold text-neutral-900">
              {stats.proximoNaFila
                ? `${stats.proximoNaFila.nome} ${stats.proximoNaFila.sobrenome}`
                : "N/A"}
            </p>
          </div>
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-info-light">
            <Phone size={24} className="text-info" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCards;
